import {CustomDivider, SectionTitle} from "../styles";
import Content, {ContentProps} from "./Content";

export interface SectionProps {
  sectionTitle: string;
  render: ContentProps[];
  sectionName?: string;
}

const Section = ({sectionTitle, render, sectionName}: SectionProps) => {
  return (
    <div data-testid={sectionName}>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <CustomDivider />
      {render.length > 0 && render.map((content: ContentProps) => <Content key={content.contentTitle} {...content} />)}
    </div>
  );
};

export default Section;
